import { render, staticRenderFns } from "./CalendarioVacaciones.vue?vue&type=template&id=2dd26617&scoped=true"
import script from "./CalendarioVacaciones.vue?vue&type=script&lang=js"
export * from "./CalendarioVacaciones.vue?vue&type=script&lang=js"
import style0 from "./CalendarioVacaciones.vue?vue&type=style&index=0&id=2dd26617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd26617",
  null
  
)

export default component.exports